export default "__VITE_ASSET__f808ed96__"